var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-bar",class:[_vm.xNotify.type, _vm.xNotify.visible ? '' : 'd-none']},[_c('p',[_vm._v(" "+_vm._s(_vm.$t(`${_vm.xNotify.message}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }